'use client';
import { __rest } from '../../node_modules/tslib/tslib.es6.js';
import { jsxs, jsx } from 'react/jsx-runtime';
import styled, { css } from 'styled-components';
import { withTitan } from '../../hocs/withTitan/withTitan.js';
import { spaceProp } from '../../mixins/spaceProp.js';
import { Box } from '../Box/Box.js';
import { Heading } from '../Heading/Heading.js';
import { Link } from '../Link/Link.js';
import { Text } from '../Text/Text.js';
import LookingGlass from './illustrations/LookingGlass.js';
import Success from './illustrations/Success.js';

const Wrapper = styled(Box).withConfig({
  componentId: "sc-v9sesf-0"
})(["max-width:", ";", ""], ({
  theme
}) => theme.components.emptyState.width, ({
  isCentered
}) => isCentered && css(["text-align:center;"]));
const IllustrationWrapper = styled.div.withConfig({
  componentId: "sc-v9sesf-1"
})(["", ""], spaceProp(4, 'margin-bottom'));
const StyledHeading = styled(Heading).withConfig({
  componentId: "sc-v9sesf-2"
})(["color:", ";"], ({
  theme
}) => theme.components.emptyState.titleColor);
const EmptyState = /*#__PURE__*/withTitan((_a, ref) => {
  var {
      children,
      description,
      illustration,
      link,
      testId = 'emptyState',
      title
    } = _a,
    props = __rest(_a, ["children", "description", "illustration", "link", "testId", "title"]);
  return jsxs(Wrapper, Object.assign({}, props, {
    ref: ref,
    children: [illustration && jsxs(IllustrationWrapper, {
      children: [illustration === 'looking-glass' && jsx(LookingGlass, {}), illustration === 'success' && jsx(Success, {})]
    }), jsx(StyledHeading, {
      heading: "h4",
      renderAs: "h2",
      spaceAfter: 2,
      testId: `${testId}Title`,
      children: title
    }), jsx(Text, {
      isBlock: true,
      color: "grey70",
      "data-test-id": `${testId}Desc`,
      spaceAfter: 4,
      type: "label",
      children: description
    }), children && jsx(Box, {
      "data-test-id": `${testId}Child`,
      spaceAfter: 4,
      children: children
    }), link && jsx(Link, {
      testId: `${testId}Link`,
      to: link.to,
      onClick: link.onClick,
      children: link.label
    })]
  }));
}, {
  name: 'EmptyState'
});

export { EmptyState };
//# sourceMappingURL=EmptyState.js.map
